import React from 'react';

// Components
import { WpCard, WpCardBody } from '..';
import { WpButton } from '../../button';

// Images
import PeopleAtDesk from '../../../../shared/images/undraw_computer_people.svg';

const CardDocs = () => {
  return (
    <>
      <div className="d-flex">
        <div style={{ maxWidth: '400px', marginRight: '2rem' }}>
          <WpCard centered>
            <WpCardBody padding={0}>
              <div style={{ backgroundColor: 'lightgrey', paddingTop: '3rem' }}>
                <img src={PeopleAtDesk} alt="" />
              </div>
            </WpCardBody>
            <WpCardBody>
              <h5>Lorem Ipsum</h5>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                ex ea commodo consequat.
              </p>
              <WpButton block>Read More</WpButton>
            </WpCardBody>
          </WpCard>
        </div>
        <div style={{ maxWidth: '400px' }}>
          <WpCard>
            <WpCardBody padding={0} centered>
              <div style={{ backgroundColor: 'lightgrey', paddingTop: '3rem' }}>
                <img src={PeopleAtDesk} alt="" />
              </div>
            </WpCardBody>
            <WpCardBody>
              <h5>Lorem Ipsum</h5>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                ex ea commodo consequat.
              </p>
              <WpButton block>Read More</WpButton>
            </WpCardBody>
          </WpCard>
        </div>
      </div>
    </>
  );
};

export default CardDocs;
